import { AbstractConfDataCommand } from "./abstractConfDataCommand";
import * as Immutable from "immutable";

export class FormCommand extends AbstractConfDataCommand
{
  formId: number;
  formControlId: number;
  valuesById: Immutable.Map<string, string>;
}